export default __webpack_public_path__ + "static/media/IBMMoreVert.db8420bf.svg";